import { ReactNode } from 'react';
import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps';

import MapPinFilled from '@rover/icons/svg/map-fill.svg';
import { Box, Text } from '@rover/kibble/core';
import type { LatLng } from '@rover/types/src/LatLng';

type Props = {
  color: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  position: LatLng<number>;
  zIndex?: number;
  content?: string;
  scale?: number;
  title?: string;
  borderColor?: string;
  children?: ReactNode;
};

const Marker = ({
  content,
  color,
  onClick,
  onMouseEnter,
  onMouseLeave,
  position,
  scale,
  zIndex,
  title,
  borderColor,
  children,
}: Props): JSX.Element | null => {
  const map = useMap();

  if (!map) return null;

  return (
    <AdvancedMarker
      position={position}
      title={title}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      draggable={false}
      zIndex={zIndex}
    >
      <Box width="22px" height="28px" sx={{ transform: `scale(${scale})` }}>
        <Box
          alignItems="center"
          justifyContent="center"
          display="flex"
          zIndex="1"
          color="white"
          position="absolute"
          width="100%"
          height="100%"
        >
          {content && (
            <Box pb="1x">
              <Text textAlign="center" size="10px" sx={{ fontWeight: '600' }}>
                {content}
              </Text>
            </Box>
          )}
          {children}
        </Box>
        <MapPinFilled width="100%" height="100%" fill={color} stroke={borderColor ?? 'none'} />
      </Box>
    </AdvancedMarker>
  );
};

export default Marker;
